// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { FloatRangeVO } from '@project/components/article/model/vo/property.vo';

@JsonObject('TextSizeCheckVO')
export class TextSizeCheckVO {

  constructor(args: Partial<TextSizeCheckVO> = {}) {
    Object.assign(this, args);
  }

  @JsonProperty('textSizeCheckClass', 'String')
  public textSizeCheckClass: string = undefined;

  @JsonProperty('textSizeCheckID', 'String')
  public textSizeCheckID: string = undefined;

  @JsonProperty('spacing', 'Number')
  public spacing: number = undefined;

  @JsonProperty('fontName', 'String')
  public fontName: string = undefined;

  @JsonProperty('fontSize', 'Number')
  public fontSize: number = undefined;

  @JsonProperty('fontBold', 'Number')
  public fontBold: number = undefined;

  @JsonProperty('compression', 'Number')
  public compression: number = undefined;

  @JsonProperty('lines', 'Number')
  public lines: number = undefined;

  @JsonProperty('chars', 'Number')
  public chars: number = undefined;

  @JsonProperty('rotation', 'Number')
  public rotation: number = undefined;

  public getUniqueKeyBasedOnAllInputTextSizeProperties(): string {
    return `textSizeCheckClass:${this.textSizeCheckClass}spacing:${this.spacing}fontName:${this.fontName}fontBold:${this.fontBold}` +
      `lines:${this.lines}chars:${this.chars}rotation:${this.rotation}`;
  }

  public createAlteredInstance(newLines: number, newChars: number): TextSizeCheckVO {
    const clone: TextSizeCheckVO = new TextSizeCheckVO;
    clone.textSizeCheckClass = this.textSizeCheckClass;
    clone.textSizeCheckID = this.textSizeCheckID;
    clone.spacing = this.spacing;
    clone.fontName = this.fontName;
    clone.fontSize = this.fontSize;
    clone.fontBold = this.fontBold;
    clone.compression = this.compression;
    clone.lines = newLines;
    clone.chars = newChars;
    clone.rotation = this.rotation;
    return clone;
  }
}

@JsonObject('TextSizeCheckRequestResponseVO')
export class TextSizeCheckRequestResponseVO {

  @JsonProperty('request', 'TextSizeCheckRequestVOConverter', true)
  public request: TextSizeCheckRequestVO = undefined;

  @JsonProperty('response', 'TextSizeCheckVOsConverter', true)
  public response: TextSizeCheckVO[] = undefined;
}

@JsonObject('TextSizeCheckRequestVO')
export class TextSizeCheckRequestVO {

  @JsonProperty('textSizeCheckClass', 'String')
  public textSizeCheckClass: string;

  @JsonProperty('spacing', 'Number')
  public spacing: number;

  @JsonProperty('spacingInRange', 'FloatRangeVO')
  public spacingInRange: FloatRangeVO = null;

}
